import { ClientLogger } from '@Praia-Health/spi-common-utils/browser';
import { v4 as uuidv4 } from 'uuid';
import { LoggerContext } from '@Praia-Health/spi-common-utils/types';

export class ApiRequestLogger extends ClientLogger {
    constructor(context?: LoggerContext) {
        super({
            context: context || {},
        });
        this.addContext({
            '@app_name': 'SPI.PECAdminPortal',
            '@type': 'log',
            correlationId: uuidv4(),
        });
    }
}
